import { render } from "./ItemList.vue?vue&type=template&id=34c786b9&scoped=true"
import script from "./ItemList.vue?vue&type=script&lang=js"
export * from "./ItemList.vue?vue&type=script&lang=js"

import "./ItemList.vue?vue&type=style&index=0&id=34c786b9&scoped=true&lang=css"

import exportComponent from "C:\\Users\\justi\\Code\\vuekillmailtool\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34c786b9"]])

export default __exports__